import { formatDate } from '@/lib/format';
/** Formats a release date (ISO `YYYY-MM-DD`) for display in the user's locale. */
export function formatReleaseDate(iso) {
    const d = new Date(`${iso}T00:00:00`);
    if (Number.isNaN(d.getTime()))
        return iso;
    return formatDate(d, { year: 'numeric', month: 'long', day: 'numeric' });
}
